import React from 'react';
import { Drawer, Freight } from '../../components';
import { useStyles } from '../../services/material-ui';
import { useHistory } from 'react-router-dom';

const ViewFreight: React.FC = () => {
  const classes = useStyles();

  const history = useHistory();

  const onPrevStep = () => {
    history.goBack();
  };

  return (
    <div className="container-dash">
      <Drawer />
      <main className={classes.content}>
        <Freight onPrevStep={onPrevStep} />
      </main>
    </div>
  );
};

export default ViewFreight;
